import { z } from 'zod'
import {
  STRATALYST_ORG_FORMS_READ_CONTRACT_VERSION,
  stratalystOrgFormRevisionSummarySchema,
  stratalystOrgFormSummarySchema,
  stratalystOrgFormsReadSideEffectsSchema,
} from './stratalyst-org-forms-read'

export const STRATALYST_ORG_FORMS_WRITE_CONTRACT_VERSION = STRATALYST_ORG_FORMS_READ_CONTRACT_VERSION

/** Request validation stays in the cookie-authenticated handlers. */
const optionalUnknown = z.unknown().optional()

export const stratalystOrgFormCreateRequestSchema = z.object({
  display_name: optionalUnknown,
  form_key: optionalUnknown,
  form_scope: optionalUnknown,
  one_off_company_id: optionalUnknown,
}).passthrough()

export const stratalystOrgFormRevisionCreateRequestSchema = z.object({
  fields: optionalUnknown,
}).passthrough()

export const stratalystOrgFormRevisionActivateRequestSchema = z.object({}).passthrough()

const writeResponseBase = {
  contract_version: z.literal(STRATALYST_ORG_FORMS_WRITE_CONTRACT_VERSION),
  replayed: z.boolean(),
  sideEffects: stratalystOrgFormsReadSideEffectsSchema,
}

export const stratalystOrgFormCreateResponseSchema = z.object({
  ...writeResponseBase,
  form: stratalystOrgFormSummarySchema,
}).passthrough()

export const stratalystOrgFormRevisionCreateResponseSchema = z.object({
  ...writeResponseBase,
  revision: stratalystOrgFormRevisionSummarySchema,
}).passthrough()

export const stratalystOrgFormRevisionActivateResponseSchema = z.object({
  ...writeResponseBase,
  revision: stratalystOrgFormRevisionSummarySchema,
}).passthrough()

export type StratalystOrgFormCreateRequest = z.infer<typeof stratalystOrgFormCreateRequestSchema>
export type StratalystOrgFormRevisionCreateRequest = z.infer<typeof stratalystOrgFormRevisionCreateRequestSchema>
export type StratalystOrgFormRevisionActivateRequest = z.infer<typeof stratalystOrgFormRevisionActivateRequestSchema>
export type StratalystOrgFormCreateResponse = z.infer<typeof stratalystOrgFormCreateResponseSchema>
export type StratalystOrgFormRevisionCreateResponse = z.infer<typeof stratalystOrgFormRevisionCreateResponseSchema>
export type StratalystOrgFormRevisionActivateResponse = z.infer<typeof stratalystOrgFormRevisionActivateResponseSchema>
